(function () {

  const DEBUG = false;
  const STORAGE_PREFIX = "ga_param_to_attr_";
  const CART_ATTR_PREFIX = "ga_attr_to_tag|";

  const paramSessionSave = [
    { param_name: "utm_source", param_value: "pinterest", expire: 2 },
    { param_name: "utm_medium", param_value: "any", expire: 2 }
  ];

  const urlParams = new URLSearchParams(window.location.search);

  function log(...args) {
    if (DEBUG) console.log("[GA PARAM TO ATTR]", ...args);
  }

  function saveToSession(key, value, expireHours) {
    const data = {
      value: value.toLowerCase(), // normalize to lowercase
      expiry: Date.now() + expireHours * 60 * 60 * 1000
    };

    sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(data));

    log("Saved to sessionStorage:", key, data.value, "expires in", expireHours, "hours");
  }

  function getSession(key) {
    const raw = sessionStorage.getItem(STORAGE_PREFIX + key);
    if (!raw) return null;

    try {
      const data = JSON.parse(raw);

      if (Date.now() > data.expiry) {
        sessionStorage.removeItem(STORAGE_PREFIX + key);
        log("Session expired for:", key);
        return null;
      }

      return data.value;

    } catch (e) {
      log("Session parse error:", key, e);
      return null;
    }
  }

  function printStorageState() {
    log("Current sessionStorage state:");
    Object.keys(sessionStorage).forEach(k => {
      if (k.startsWith(STORAGE_PREFIX)) {
        log(k, sessionStorage.getItem(k));
      }
    });
  }

  function processUrlParams() {
    log("Page URL:", window.location.href);
    log("URL Params:", Object.fromEntries(urlParams.entries()));

    paramSessionSave.forEach(rule => {

      if (!urlParams.has(rule.param_name)) return;

      const value = urlParams.get(rule.param_name);

      const ruleValue = rule.param_value.toLowerCase();
      const paramValue = value.toLowerCase();

      log("Checking rule:", rule, "against value:", value);

      if (ruleValue === "any" || paramValue === ruleValue) {
        log("Rule matched -> saving param");
        saveToSession(rule.param_name, value, rule.expire);
      } else {
        log("Rule did not match");
      }

    });
  }

  function syncCartAttributes() {

    const attributes = {};

    paramSessionSave.forEach(rule => {
      let value = getSession(rule.param_name);

      if (value) value = value.toLowerCase(); // ensure lowercase before sending to cart

      const attrName = CART_ATTR_PREFIX + rule.param_name;
      attributes[attrName] = value || "";
    });

    log("Cart attribute payload:", attributes);

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes })
    })
      .then(res => res.json())
      .then(data => log("Cart update response:", data))
      .catch(err => console.error("[GA PARAM TO ATTR] Cart update error:", err));
  }

  function init() {
    log("===== INIT GA PARAM TRACKER =====");
    processUrlParams();
    printStorageState();
    syncCartAttributes();
  }

  document.addEventListener("DOMContentLoaded", init);

})();